<template>
  <div class="Page" :style="'background:'+background" ref="homePage"  >
    <!--   v-if="code!=''&&code!=null"  -->
    <slot></slot>
    <scrollTop v-if="top"></scrollTop>
  </div>
</template>



<script>
import scrollTop from "../scrollTop";
export default {
  name: "Page",
  props: {
    // 在该视图上的高度
    background: {
      type: String,
      default: "#F4F4F4"
    },
    title: {
      type: String,
      default: "首页"
    }
  },
  data() {
    return {
      clientHeight: "",
      bodyHeight:document.documentElement.clientHeight,
      code: " ",
      top:false
    };
  },
  mounted() {
    localStorage.removeItem('heights')
    // 获取浏览器可视区域高度
    this.clientHeight = `${document.documentElement.clientHeight}`;
      localStorage.setItem('heights', this.clientHeight);
    window.onresize = function temp() {
      this.clientHeight = `${document.documentElement.clientHeight}`;
      localStorage.setItem('heights', this.clientHeight);
    };
    this.code = this.codes = localStorage.getItem("code");

    document.addEventListener('scroll',this.handelscroll)
  },
  computed: {},
  components:{
    scrollTop
  },
  /**
   *  监听
   */
  watch: {
    // 如果 `clientHeight` 发生改变，这个函数就会运行
    clientHeight: function() {
      this.changeFixed(this.clientHeight);
    }
  },
  created() {},
  methods: {
    changeFixed(clientHeight) {
      //动态修改样式
      this.$refs.homePage.style.maxHeight = clientHeight + "px";
      if(this.bodyHeight>clientHeight){
      }else{
         this.$refs.homePage.style.maxHeight = clientHeight + "px";  
      }
    }
  }
};
</script>
<style lang="less" src="~c/index-Page.less"></style>










// WEBPACK FOOTER //
// src/globalComponent/Page/index.vue